var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87873 11.259C9.87873 11.259 11.9607 11.1037 11.9607 8.65054C11.9607 6.19725 10.2574 5 8.09979 5H1V18.7093H8.09979C8.09979 18.7093 12.434 18.8469 12.434 14.663C12.434 14.663 12.6229 11.259 9.87873 11.259ZM7.58876 7.43668H8.09979C8.09979 7.43668 9.06486 7.43668 9.06486 8.86308C9.06486 10.2893 8.4973 10.4961 7.85353 10.4961H4.12826V7.43668H7.58876ZM7.89917 16.2727H4.12826V12.6091H8.09979C8.09979 12.6091 9.53819 12.5901 9.53819 14.4918C9.53819 16.0954 8.46385 16.2606 7.89917 16.2727ZM18.2143 8.48806C12.9673 8.48806 12.972 13.7556 12.972 13.7556C12.972 13.7556 12.612 18.9961 18.2143 18.9961C18.2143 18.9961 22.8829 19.2641 22.8829 15.3506H20.4819C20.4819 15.3506 20.562 16.8244 18.2944 16.8244C18.2944 16.8244 15.893 16.9861 15.893 14.4392H22.9629C22.9629 14.4392 23.7365 8.48806 18.2143 8.48806ZM15.8666 12.6091C15.8666 12.6091 16.1598 10.496 18.2677 10.496C20.375 10.496 20.3487 12.6091 20.3487 12.6091H15.8666ZM20.908 7.49586H15.2788V5.80766H20.908V7.49586Z",
    fill: "#697077"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/Behance.0f18b557.svg";
export { ForwardRef as ReactComponent };